import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const BiltyNewPage = lazy(() => import("@/pages/bilty.new.page"));

export const Route = createFileRoute("/bilty/new")({
  component: BiltyNewPage,
});
